import { gql } from "@apollo/client";

const policiesQueryDocument = gql`
  query policiesQuery(
    $limit: Int
    $page: Int
    $countryId: Int
    $themeId: Int
    $startYear: Int
    $endYear: Int
    $geographicalAreaId: Int
  ) {
    policies(
      limit: $limit
      page: $page
      countryId: $countryId
      themeId: $themeId
      startYear: $startYear
      endYear: $endYear
      geographicalAreaId: $geographicalAreaId
    ) {
      collection {
        id
        title
      }
    }
  }
`;

const fetchPracticesQueryDocument = gql`
  query FetchPracticesQuery(
    $limit: Int
    $page: Int
    $countryId: Int
    $themeId: Int
    $startYear: Int
    $endYear: Int
  ) {
    practices(
      limit: $limit
      page: $page
      countryId: $countryId
      themeId: $themeId
      startYear: $startYear
      endYear: $endYear
    ) {
      collection {
        id
        title
      }
    }
  }
`;

const peopleQueryDocument = gql`
  query People(
    $limit: Int
    $page: Int
    $countryId: Int
    $themeId: Int
    $startYear: Int
    $endYear: Int
  ) {
    people(
      limit: $limit
      page: $page
      countryId: $countryId
      themeId: $themeId
      startYear: $startYear
      endYear: $endYear
    ) {
      collection {
        id
        title
      }
    }
  }
`;

const defaultQuery = gql`
  query {
    defaultField {
      id
      name
    }
  }
`;

const SUPPORT_REQUEST_CREATE = gql`
  mutation SupportRequestCreate($input: SupportRequestInput!) {
    supportRequestCreate(input: { supportRequestInput: $input }) {
      clientMutationId
      supportRequest {
        category
        createdAt
        email
        firstname
        id
        lastname
        message
        personId
        phoneNumber
        policyId
        practiceId
        updatedAt
      }
    }
  }
`;

export {
  policiesQueryDocument,
  fetchPracticesQueryDocument,
  peopleQueryDocument,
  defaultQuery,
  SUPPORT_REQUEST_CREATE
};
